define([
	"dojo/_base/declare",
	"csi/action",
	"csi/sessionConstants",
	"csi/service/sessionService",
	"csi/table/Delete"
], function(declare,csiAction,sessionConstants,{ initializeRoles },Delete) {

	return declare(Delete, {
        constructor: function () {
            this._bPlayed = this.m_urlNode == sessionConstants.roleUrl;
            this._bManaged = this.getNode().ManagePreferences;
        },

        getString: function(/*String*/suffix, /*String[]?*/params) {
    		// DE25267: if the user is playing the role replace the usual confirmation message with a confirmation message
    		// for deleting a played role
        	if (this._bPlayed && ((suffix == csiAction.SUFFIX_CONFIRM) || (suffix == csiAction.SUFFIX_PROMPT))) {
				suffix += "_Played";
        	}

        	return this.inherited(arguments, [suffix, params]);
        },

		postProcess: function (/*Boolean*/bStatus) {
			// summary: if role deleted and was role played by user, then refresh page; otherwise just refresh list of played roles
			if (bStatus) {
				if (this._bPlayed) {
					location.reload();
					return;
				} else if (this._bManaged) {
					initializeRoles();
				}
			}

		    return this.inherited(arguments);
		}
	});
});